import { CustomerService } from "@/services/api/customer.service";
import { basePagesMutations } from "@/store/base-pages";

const state = {
  items: [],
  theader: [],
  gdata: [],
};

export default {
  namespaced: true,

  state: { ...state },

  mutations: {
    ...basePagesMutations,
  },

  actions: {
    removeItem({ commit, rootState }, parameter) {
      return CustomerService.removeParameter(rootState.customer.id, parameter.id).then(response => {
        if (response.success) {
          commit("REMOVE_ITEM", parameter);
        }
      });
    },
  },
};
